import { Routes } from "@angular/router";
import { AdminOrganizationsEditTabComponent } from "./edit/admin-organizations-edit-tab.component";
import { organizationResolver } from "./edit/admin-organizations-edit.resolver";

export const routes: Routes = [
    {
        path: "organizations",
        loadComponent: () => import("./admin-organizations.component").then((c) => c.AdminOrganizationsComponent),
        data: {
            roles: ["SysAdmin"],
            reuse: (previousUrl: string) => previousUrl.startsWith("/admin/organizations/")
        }
    },
    {
        path: "organizations/add",
        loadComponent: () => import("./add/admin-organizations-add.component").then((c) => c.AdminOrganizationsAddComponent),
        data: {
            roles: ["SysAdmin"]
        },
        children: [{ path: "contact", component: AdminOrganizationsEditTabComponent }]
    },
    {
        path: "organizations/:id",
        loadComponent: () => import("./edit/admin-organizations-edit.component").then((c) => c.AdminOrganizationsEditComponent),
        resolve: {
            organization: organizationResolver
        },
        data: {
            roles: ["SysAdmin"]
        },
        children: [
            { path: "", redirectTo: "details", pathMatch: "full" },
            { path: "**", component: AdminOrganizationsEditTabComponent }
        ]
    }
];
